import We_check_Logo_Color from "./imgs/We_check-Logo-Color.png";

export const logo = We_check_Logo_Color;

